var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "ProjectInfo",
    },
    [
      _c(
        "div",
        { staticStyle: { width: "260px", height: "calc(100vh - 70px)" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                height: "50px",
                display: "flex",
                "align-items": "center",
                padding: "0 20px",
              },
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "100%",
                    height: "30px",
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    "font-size": "14px",
                  },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                },
                [
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _c("i", {
                      staticClass: "el-icon-back",
                      staticStyle: { "margin-right": "10px" },
                    }),
                    _vm._v(" 后退前页"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-menu",
            {
              ref: "menuTree",
              staticClass: "el-menu-vertical-demo",
              attrs: { "default-active": _vm.activeName, router: "" },
            },
            [
              _c(
                "el-menu-item",
                {
                  attrs: {
                    index: "/ProjectInfo/ProjectAll?id=" + this.$ProjectId,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-monitor" }),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("工作台"),
                  ]),
                ]
              ),
              _vm._l(_vm.MenuTteeData, function (item) {
                return _c(
                  "el-submenu",
                  { key: item.Id, attrs: { index: item.Id } },
                  [
                    _c("template", { slot: "title" }, [
                      _c("i", {
                        class:
                          _vm.menuValue == 0
                            ? "el-icon-office-building"
                            : "icon-gongyingshang1 icon",
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "inline-block",
                            "white-space": "normal",
                          },
                        },
                        [_vm._v(_vm._s(item.title))]
                      ),
                    ]),
                    _vm._l(item.children, function (ele) {
                      return _c(
                        ele.Type == 2 ? "el-submenu" : "el-menu-item",
                        {
                          key: ele.title,
                          tag: "component",
                          attrs: {
                            index: ele.path || ele.Id,
                            "popper-class": "popper-menu",
                          },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("i", { staticClass: "el-icon-edit-outline" }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "white-space": "normal",
                                },
                              },
                              [_vm._v(_vm._s(ele.title))]
                            ),
                          ]),
                          ele.children && ele.children.length > 0
                            ? _vm._l(ele.children, function (v) {
                                return _c(
                                  "el-menu-item",
                                  {
                                    key: v.Id,
                                    staticClass: "menu-item",
                                    attrs: { index: v.path || v.Id },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-edit-outline",
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          "white-space": "normal",
                                        },
                                        attrs: { slot: "title" },
                                        slot: "title",
                                      },
                                      [_vm._v(_vm._s(v.title))]
                                    ),
                                  ]
                                )
                              })
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "tabsBut" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  on: { "tab-click": _vm.menuChange },
                  model: {
                    value: _vm.menuValue,
                    callback: function ($$v) {
                      _vm.menuValue = $$v
                    },
                    expression: "menuValue",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "设备审核", name: "0" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "资料审核", name: "1" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            width: "calc(100% - 260px)",
            height: "calc(100vh - 70px)",
            overflow: "hidden",
          },
        },
        [_c("router-view")],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }